var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004540"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5304",
    width: 58.8621,
    height: 58.8621,
    rx: 20,
    fill: "#66D763"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427318463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7739 37.4382V37.7293V43.0911C19.7739 44.7227 21.6455 45.5175 22.7868 44.4668C22.7872 44.4665 22.7876 44.4661 22.7879 44.4658L24.858 42.5418L25.2844 42.1455L25.774 42.4601C27.1999 43.3763 28.5042 43.9628 29.4795 44.1207L29.4821 44.1211C30.6901 44.321 31.6623 44.1819 32.5041 43.7766C33.3574 43.3657 34.1389 42.6514 34.9065 41.5984C36.4636 39.4623 37.8216 36.1436 39.5886 31.7741C42.1049 25.5495 43.2433 21.6884 43.5597 19.1972C43.7171 17.9585 43.6652 17.1002 43.5045 16.4785C43.3479 15.8729 43.0802 15.4599 42.7423 15.1162L42.5272 14.8973V14.8902C42.2335 14.6426 41.8827 14.4472 41.4139 14.3231C40.8086 14.1629 39.9701 14.1119 38.7549 14.2733C36.3102 14.5978 32.5179 15.7548 26.3996 18.3017C22.1042 20.0996 18.8453 21.48 16.7477 23.0626C15.7145 23.8422 15.0108 24.6377 14.6051 25.5099C14.2039 26.3724 14.0663 27.3692 14.2639 28.605L19.7739 37.4382ZM19.7739 37.4382L19.5775 37.2234M19.7739 37.4382L19.5775 37.2234M19.5775 37.2234C18.2477 35.7685 16.9973 34.1516 16.0366 32.6143M19.5775 37.2234L16.0366 32.6143M16.0366 32.6143C15.065 31.0596 14.4319 29.6527 14.2639 28.6052L16.0366 32.6143Z",
    fill: "#60CE5E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.2772 14.5644C41.5887 12.8465 38.3651 12.5082 26.1105 17.6097C17.5912 21.1755 12.6535 23.2838 13.5234 28.7236C13.9071 31.1182 16.312 34.7622 19.0239 37.7293V43.0911C19.0239 45.3556 21.659 46.5268 23.2963 45.0172L25.3686 43.0911C26.8269 44.0281 28.234 44.6788 29.3597 44.861C34.7067 45.746 36.779 40.7226 40.2839 32.0552C45.3239 19.5878 44.9657 16.3083 43.2772 14.5904V14.5644Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.1139 14.8843L18.2689 37.9505C15.8702 35.0469 13.8503 31.6548 13.5221 29.3753C12.6636 23.7038 17.5367 21.5057 25.9446 17.7879C38.0388 12.4691 41.2202 12.8219 42.8866 14.6129C42.9624 14.6944 43.0381 14.7758 43.1139 14.8843Z",
    fill: "#BCEB80",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon_send.907b8276fafb6c42b54cb2c92fece845.svg";
export { ForwardRef as ReactComponent };